import MessageTechnical from "./MessageTechnical";
export default MessageTechnical;